import styled from 'styled-components';

import { Text } from '../../../../components';
import { COLORS, SPACE, STATUS_COLORS } from '../../../../theme/tokens';

/** The popup's body in both phases: one column (the Modal's own body gap does not reach inside it). */
export const Fields = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${SPACE[12]};
`;

/** One name field with its helper and its error, kept closer together than the fields are to each
 *  other (the same 8px as the field's label to its input). */
export const FieldGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${SPACE[8]};
`;

/** A line of the popup (Start over's warning). Muted, as the area's dialog lines are. */
export const Line = styled(Text)`
  display: block;
  margin: ${SPACE[0]};
  font-size: 14px;
  line-height: 1.5;
  color: ${COLORS.textMuted};
`;

/** What a name field is for, under it. */
export const Helper = styled(Text)`
  display: block;
  font-size: 12px;
  line-height: 1.4;
  color: ${COLORS.textMuted};
`;

/** Why a name cannot be sent, under its helper. A plain element so it carries its role and test id. */
export const FieldError = styled.div`
  font-size: 12px;
  line-height: 1.4;
  color: ${STATUS_COLORS.negative};
`;
